import * as React from "react";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { SEARCH_FILTERS_GROUP } from "../../../../../../../config/search/filters/groupsConfig";
import { store } from "../../../../../../../store/redux/store";
import { NomenclatureAutocompleteFilter } from "@duosoftbg/nacid-components";
import { referenceDataDomainsThunk } from "../../../../../../../store/redux/slice/AppData/referenceDataDomains";

const ReferenceDataDomainFilter = () => {
  const group = SEARCH_FILTERS_GROUP.REFERENCE_DATA;

  const thunkState = useAppSelector((state) => {
    return state.AppData.referenceDataDomains;
  });

  const getPreviousStateOptionFn = () => {
    const domain = store.getState().SearchData.portalSearchTable[group].filtersData.domain;
    const options = store.getState().AppData.referenceDataDomains.data;
    return options.find((element) => element.id === domain);
  };

  return (
    <NomenclatureAutocompleteFilter
      filter={"domain"}
      thunkFn={referenceDataDomainsThunk}
      thunkState={thunkState}
      getPreviousStateOptionFn={getPreviousStateOptionFn}
    />
  );
};

export default ReferenceDataDomainFilter;
